// extracted by mini-css-extract-plugin
module.exports = {"nav":"ClassicFixedSingleLineNav_nav__Rw_MS","anchor":"ClassicFixedSingleLineNav_anchor__8bQ3g"};